import { Ajax } from "../../../Common/Ajax";
import { GlobalData } from "../../../Common/GlobalData";
import { Confirm, Notification, TemplateHelpers } from "../../../Common/KendoHelpers";

export class Index {
    private readonly NUM_DAYS = '#numDays';
    private readonly UPDATE_NUM_DAYS = '#updateNumDays';
    private readonly GRID = '#grid';

    constructor() {
        this.init();
    }

    private init() {
        $(this.NUM_DAYS).kendoNumericTextBox({
            value: 25,
            format: '0',
            decimals: 0,
            min: 1
        });

        $(this.UPDATE_NUM_DAYS).on('click', () => {
            var grid = $(this.GRID).data('kendoGrid')!;
            grid.dataSource.pageSize(this.getNumDays());
        });

        $(this.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: GlobalData.URL_BASE + 
                    GlobalData.URL_SUFFIX_IBD_LEADERBOARD_THE_BIG_PICTURE
                },
                pageSize: this.getNumDays(),
                serverPaging: true,
                serverSorting: true,
            },
            height: 915,
            groupable: false,
            sortable: false,
            pageable: false,
            detailInit: this.openDetail,
            columns: [{
                field: 'tradingDate',
                title: 'Trading<br>Date',
                width: '73px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-right' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('tradingDate')),
            }, {
                title: 'Day',
                width: '43px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getTradingDayTemplate('tradingDate')),
            }, {
                field: 'dailyAction',
                title: 'Daily Action',
                width: '240px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-left' },
            }, {
                field: 'currentOutlook',
                title: 'Current Outlook',
                width: '140px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template($('#CurrentOutlook-template').html()),
            }, {
                field: 'distributionDays',
                title: 'Distribution Days',
                width: '152px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'ndqChange',
                title: 'NDQ<br>Chg',
                width: '45px',
                headerAttributes: { 'class': 'table-header-cell grid-header-10' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template($('#NdqChange-template').html()),
            }, {
                field: 'ndqCount',
                title: 'NDQ<br>Cnt',
                width: '45px',
                headerAttributes: { 'class': 'table-header-cell grid-header-10' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'sandP500Count',
                title: 'SP500<br>Cnt',
                width: '45px',
                headerAttributes: { 'class': 'table-header-cell grid-header-10' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'sandP500Change',
                title: 'SP500<br>Chg',
                width: '45px',
                headerAttributes: { 'class': 'table-header-cell grid-header-10' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template($('#SandP500Change-template').html()),
            }, {
                field: 'pctInvest',
                title: 'Min %<br/>Invest',
                width: '60px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template($('#PctInvest-template').html()),
            }]
        });
    }

    private getNumDays() {
        return parseInt($(this.NUM_DAYS).val()?.toString() || '');
    }

    private openDetail(e: any) {
        const urlSuffix = GlobalData.URL_SUFFIX_IBD_LEADERBOARD_THE_BIG_PICTURE +
            '/Detail?tradingDate=' + e.data.tradingDate;

        const success = (data: any) => {
            if (e.detailCell != null) {
                e.detailCell.html(data);
            }
        };

        const error = () => {
            e.detailCell = null;
        }

        Ajax.invoke(urlSuffix, 'GET', null, success, error);
    }

    public delete(tradingDate: string) {
        const onDone = () => {
            const urlSuffix = GlobalData.URL_SUFFIX_IBD_LEADERBOARD_THE_BIG_PICTURE +
                '?tradingDate=' + tradingDate;
            const msg = new Notification();

            const success = () => {
                msg.success('The record for ' + tradingDate + ' was deleted successfully');
                $(this.GRID).data('kendoGrid')?.dataSource.read();
            };

            const error = () => {
                msg.error('The record for ' + tradingDate + ' could not be deleted');
            }

            Ajax.invoke(urlSuffix, 'DELETE', null, success, error);
        };

        const onFail = () => {
            // Do nothing.
        };

        const confirm = new Confirm(
            'Are you sure you want to delete the record for ' + tradingDate + '?',
            onDone, onFail);
        confirm.show();
    }
}
